<template>
  <section class="modern-notifications-preview" aria-labelledby="modern-notifications-title">
    <div class="modern-account-menu__section-heading">
      <h3 id="modern-notifications-title">Notificaciones</h3>
      <span v-if="state.unreadCount">{{ state.unreadCount }} {{ state.unreadCount === 1 ? 'pendiente' : 'pendientes' }}</span>
    </div>
    <p v-if="state.status === 'loading' && !state.items.length" class="modern-account-menu__muted">Cargando…</p>
    <p v-else-if="state.status === 'error' && !state.items.length" class="modern-account-menu__error">No se pudieron cargar.</p>
    <p v-else-if="!state.items.length" class="modern-account-menu__muted">No tienes avisos recientes.</p>
    <ul v-else>
      <li v-for="item in state.items" :key="item.id" :class="{ 'is-unread': !item.read }">
        <span>{{ item.title }}</span>
        <time v-if="item.createdAt" :datetime="dateTime(item.createdAt)">{{ relativeDate(item.createdAt) }}</time>
      </li>
    </ul>
    <button v-if="state.unreadCount" class="modern-account-menu__text-action" type="button" @click="$emit('mark-read')">
      Marcar todas como leídas
    </button>
  </section>
</template>

<script>
export default {
  name: 'ModernNotificationsPreview',
  props: { state: { type: Object, required: true } },
  methods: {
    dateTime(timestamp) { return new Date(timestamp * 1000).toISOString(); },
    relativeDate(timestamp) {
      const days = Math.floor((Date.now() - timestamp * 1000) / 86400000);
      if (days <= 0) return 'Hoy';
      if (days === 1) return 'Ayer';
      return `Hace ${days} días`;
    }
  }
};
</script>
